var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{on:{"click":_vm.handleConnect}},[_c('img',{attrs:{"src":require("@/assets/images/phantom_small.png")}}),_vm._t("default"),_vm._v(" "+_vm._s(_vm.connected ? _vm.shortAddr : _vm.wallet_addr))],2)
}
var staticRenderFns = []

export { render, staticRenderFns }